// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IModuleI18n } from '@platform/core/types/modularity/IModuleI18n';
import type { IModuleManifest } from '@platform/core/types/modularity/IModuleManifest';

/** Пакет модуля «Прес-релізи» (Press releases, ключ `press`, група `communications`). */
export const pressReleasesManifest: IModuleManifest = {
  key: 'press',
  group: 'communications',
  slug: 'press-releases',
  prefix: 'PRS',
  name: { en: 'Press releases', uk: 'Прес-релізи' },
  entities: [
    { key: 'press', slug: 'press', name: { en: 'Press releases', uk: 'Прес-релізи' }, main: true },
    { key: 'release_approval', slug: 'release-approval', name: { en: 'Release Approvals', uk: 'Погодження' }, main: false },
    { key: 'release_distribution', slug: 'release-distribution', name: { en: 'Release Distributions', uk: 'Розповсюдження' }, main: false },
    { key: 'release_version', slug: 'release-version', name: { en: 'Release Versions', uk: 'Версії' }, main: false },
    { key: 'release_coverage', slug: 'release-coverage', name: { en: 'Release Coverages', uk: 'Висвітлення в медіа' }, main: false },
    { key: 'release_status', slug: 'release-status', name: { en: 'Release Statuses', uk: 'Статуси' }, main: false },
  ],
  loadState: () => import('./state/pressReleasesSlice').then((m) => m.pressReleasesSlice),
  loadI18n: (lng) => (lng === 'uk' ? import('./i18n/uk.json') : import('./i18n/en.json')).then((m) => m.default as IModuleI18n),
  loadDefinition: () => import('./definition').then((m) => m.definition),
};
